/**
 * Created by tschenkel on 9/7/2015.
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { TestEnvironment } from "./TestEnvironment";
import { IEnvironment } from "./IEnvironment";

export class FeatureBranchQualityAssuranceEnvironment extends TestEnvironment implements IEnvironment {
    public static FEATURE_BRANCH_QUALITY_ASSURANCE_ENVIRONMENT: string = "FeatureBranchQualityAssuranceEnvironment";

    constructor() {
        super(FeatureBranchQualityAssuranceEnvironment.FEATURE_BRANCH_QUALITY_ASSURANCE_ENVIRONMENT);
    }

    public initPatterns(): void {
        super.initPatterns();

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/branch_feature_{featureBranchId}/{featureBranchEnvironment}/branches/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/branch_feature_{featureBranchId}/{featureBranchEnvironment}/branches/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isFeatureBranchEnvironment;
    }
}
